import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "./Products.css";

/* IMAGES */
import fippImg from "../../assets/services-21.jpg";
import fappImg from "../../assets/services-22.jpg";
import finalBanner from "../../assets/finalbanner.png";
import selectionChart from "../../assets/fc.jpg";
import isoPump from "../../assets/services-23.jpg";
import ansiPump from "../../assets/services-24.jpg";

/* PRODUCT GRID DATA */
const models = [
  {
    id: "ISO 5199",
    name: "Flowtech – Process Pump – ISO 5199",
    img: isoPump,
  },
  {
    id: "ANSI B 73.1",
    name: "Flowtech – Chemical Process Pump – ANSI B 73.1",
    img: ansiPump,
  },
];

const ProcessPumps = () => {
  return (
    <div className="cyber-root">
      {/* ================= HERO ================= */}
      <section
        className="hud-hero"
        style={{
          backgroundImage: `
            linear-gradient(
              to bottom,
              rgba(143,182,243,0.65),
              rgba(214,230,250,0.55),
              rgba(255,255,255,0.75)
            ),
            url(${finalBanner})
          `,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="hero-content">
          <motion.h1
            className="hero-main-title"
            initial={{ opacity: 0, x: -60 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9 }}
          >
            CENTRIFUGAL PROCESS PUMP
          </motion.h1>
        </div>
      </section>

      <div className="dashboard-container">
        {/* ================= SIDEBAR ================= */}
        <aside className="sidebar-nav">
          <h3>Product Categories</h3>
          <nav className="nav-buttons">
            <Link to="/products/transformer-oil-pumps">
              Glandless Transformer Oil Pumps
            </Link>
            <Link to="/products/monoblock-pumps">
              Self-Priming Monoblock Pumps
            </Link>
            <Link to="/products/canned-motor-pumps">
              Sealless Canned Motor Pumps
            </Link>
            <Link to="/products/marine-pumps">
              Marine Centrifugal Pumps
            </Link>
            <Link className="active" to="/products/process-pumps">
              Centrifugal Process Pump
            </Link>
          </nav>
          <button className="side-btn">Download Brochure</button>
        </aside>

        {/* ================= MAIN CONTENT ================= */}
        <main className="industrial-panel">
          <h2>Centrifugal Process Pump</h2>
<br/>
          {/* ================= FIPP ================= */}
          <section className="process-section">
            <h3>FIPP Process Pump (DIN EN ISO 2858 / 5199)</h3>
<br/>
            <p className="company-description">
              The FIPP Pump is an End Suction, Top Discharge, Single Stage
              Overhung, Horizontal Radial Split, and Heavy Duty Chemical Process
              Pump Designed and manufactured as per DIN EN ISO 2858 / 5199.
              All FIPP pumps are designed around a single, basic hydraulic and
              mechanical design concept. This ensures efficiencies across a wide
              spectrum of operating conditions, unmatched application
              flexibility and superior interchangeability.
            </p>

            <p className="company-description">
              This centrifugal pump is designed to operate dependably for long
              periods of time, even in the toughest industrial applications.
            </p>

            <p className="company-description">
              Heavy duty casing of back pull-out design with a fully confined
              gasket and with integral foot and multi-ribbed discharge flange and
              over 26 sizes to precisely meet service conditions within a wide
              range of hydraulic parameters.
            </p>
<br/>
            <h4>Operating Data</h4>
            <br/>
            <ul className="product-range-list">
              <li>Capacity – Upto 900 M3/Hr</li>
              <li>Head – Upto 160 Mtrs</li>
              <li>Temperature – Upto 210°C</li>
              <li>Casing Pressure – Upto 22 Bar</li>
              <li>Pump Size – 32 mm to 200 mm</li>
            </ul>

            <p className="note-text">
              For Pump Operation Outside Of This Range, Please Contact A FlowTech
              Representative
            </p>

            {/* SELECTION CHART */}
            <div className="selection-chart-box">
              <h4 className="selection-title">SELECTION CHART</h4>
              <img
                src={selectionChart}
                alt="Selection Chart"
                className="selection-chart-img"
              />
            </div>

            <img src={fippImg} alt="FIPP Process Pump" className="process-img" />
          </section>

          <div className="divider-line" />

          {/* ================= FAPP ================= */}
          <section className="process-section">
            <h3>FAPP Process Pump (ANSI B 73.1)</h3>
<br/>
            <p className="company-description">
              The FAPP Pump is an End Suction, Top Discharge, Single Stage
              Overhung, Horizontal Radial Split, and Heavy Duty Chemical Process
              Pump Designed and manufactured as per ANSI B73.1. All FAPP pumps
              are designed around a single, basic hydraulic and mechanical
              design concept. This ensures efficiencies across a wide spectrum
              of operating conditions, unmatched application flexibility and
              superior interchangeability.
            </p>

            <p className="company-description">
              Heavy duty casing of back pull-out design with a fully confined
              gasket and with integral foot and multi-ribbed discharge flange
              and over 32 sizes to precisely meet service conditions within a
              wide range of hydraulic parameters.
            </p>
<br/>
            <h4>Operating Data</h4>
            <br/>
            <ul className="product-range-list">
              <li>Capacity – Upto 600 M3/Hr</li>
              <li>Head – Upto 180 Mtrs</li>
              <li>Temperature – Upto 200°C</li>
              <li>Casing Pressure – Upto 24 Bar</li>
              <li>Pump Size – 25 mm to 200 mm</li>
            </ul>

            <img src={fappImg} alt="FAPP Process Pump" className="process-img" />
          </section>

          {/* ================= APPLICATIONS ================= */}
          <section className="applications-section">
            <h3>Applications</h3>
            <div className="applications-grid">
              <ul>
                <li>Petrochemical</li>
                <li>Oil & Gas</li>
                <li>Steel Industry</li>
                <li>Automotive</li>
                <li>Agriculture</li>
                <li>Tank Farm</li>
                <li>Pulp and Paper</li>
                <li>Chemical</li>
                <li>Mining</li>
              </ul>

              <ul>
                <li>Semiconductor</li>
                <li>Food Processing</li>
                <li>Power Generation</li>
                <li>Pharmaceuticals</li>
                <li>Water Treatment</li>
                <li>Paper Stock</li>
                <li>Pipeline</li>
                <li>General Industries</li>
                <li>Textile</li>
              </ul>
            </div>
          </section>

          {/* ================= PRODUCT GRID ================= */}
          <section className="product-models-section">
            <div className="product-grid">
              {models.map((m) => (
                <div key={m.id} className="pump-card">
                  <div className="img-holder">
                    <span className="pump-id">{m.id}</span>
                    <img src={m.img} alt={m.name} />
                  </div>
                  <br/>
                  <p className="pump-name">{m.name}</p>
                  <br/>
                                 <Link to="/products/process-pumps" onClick={() => window.scrollTo(0, 0)}> 
                    <button className="view-btn">View Datasheet</button>
                  </Link>
                </div>
              ))}
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default ProcessPumps;
